import { createAction } from '@reduxjs/toolkit';
import { ActionNames } from '_constants'

export const messageCenterActions = {
    categoryChange: createAction(ActionNames.MESSAGE_CATEGORY_CHANGE)
}
